import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UndecoratedInvestor } from '@flemingmetrics/api-client';
import { setCurrentUser } from './currentUserSlice';

type CurrentInvestorState = UndecoratedInvestor | null;

const initialState =
  null satisfies CurrentInvestorState as CurrentInvestorState;

export const currentInvestorSlice = createSlice({
  name: 'currentInvestor',
  initialState,
  reducers: {
    setCurrentInvestor: (state, action: PayloadAction<UndecoratedInvestor>) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setCurrentUser, (state, action) => {
        return action.payload.investor || state;
      })
      .addDefaultCase(() => {});
  },
});

export const { setCurrentInvestor } = currentInvestorSlice.actions;

export default currentInvestorSlice.reducer;
